import React, { useState } from 'react';
import { useTranslation } from '../../services/LanguageContext';
import '../home/home.scss';

const IOSInvitation = () => {
    const { t } = useTranslation(); 
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://find-together-api.sslbeta.de/api/Support/notifyFutureSubscriber?email=${encodeURIComponent(email)}`, {
                method: 'POST',
                headers: {
                    'accept': '*/*',
                },
                body: '', 
            });
    
            if (response.ok) {
                console.log('Email submitted successfully');
                setSubmitted(true); 
            } else {
                console.error('Failed to submit email');
            }
        } catch (error) {
            console.error('Error occurred while submitting email', error);
        }
    };  

    return (
        <>
            <div className="hero-section">
                <div className="hero-overlay d-flex flex-column align-items-center justify-content-center">
                    <h2 className='text-white'>{t('ios_hero_title', 'Finden Sie Ihren perfekten Partner')}</h2>
                    <span className='hero--ios-text-margin'> </span>
                    <div className="notify-section">
                        <p className="email-notice mt-2">
                            {t('ios_email_notice', 'Leider unterstützt der Apple AppStore keine Beta-Versionen. Dennoch können Sie unsere App bereits testen, indem Sie sich für unsere Tester-Liste registrieren. Geben Sie einfach Ihre Mail-Adresse an und werden Sie bereits heute Nutzer von Find-Together!')}
                        </p>
                        {!submitted ? (
                            <form onSubmit={handleSubmit} className="notify-input-container">
                                <input
                                    type="email"
                                    placeholder={t('ios_email_placeholder', 'E-mail')}
                                    className="custom-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <button type="submit" className="custom-button">
                                    {t('ios_register_button', 'Registrieren')}
                                </button>
                            </form>
                        ) : (
                            <p>{t('ios_success_message', 'Vielen Dank! Sie werden eine TestFlight-Einladung per E-Mail erhalten.')}</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default IOSInvitation;
